import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";

const LineupRequirements = (props) => {
  // const [contestData, setContestData] = useState(props.contestData);
  const [defaultAccordion, setDefaultAccordion] = useState(
    props.defaultAccordion
  );

  return (
    <Accordion defaultActiveKey={defaultAccordion} className="rules-accordion">
      <Accordion.Item eventKey="3">
        <Accordion.Header>Lineup Requirements</Accordion.Header>
        <Accordion.Body>
          <p>C - 1, F - 2, G - 2, F/C - 1, G/F - 1</p>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default LineupRequirements;
